import useTourManager from '../../hooks/useTourManager';
import { tourSteps } from '../../config/contactRequestsConfig';

const useContactRequestsTour = ({
  isAuthenticated,
  dataReady,
  hasSeenNavbarTour
}) => {
  // Use shared tour manager
  const { startTour } = useTourManager({
    tourName: 'contactRequestsTour',
    cookieName: 'contactRequestsTourSeen',
    isAuthenticated,
    dataReady,
    hasSeenNavbarTour,
    pageSteps: tourSteps
  });

  return { startTour };
};

export default useContactRequestsTour;
